module.exports = __webpack_public_path__ + "static/img/bg-pt.b30f93b8.webp";